const affiliateArrowLeft = (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 27.334L11 16.834L21 6.33398"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const affiliateArrowRight = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none">
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="2"
      d="m11 6.334 10 10.5-10 10.5"
    />
  </svg>
);

export { affiliateArrowLeft, affiliateArrowRight };
